export function generateTimeSlots(date) {
    const slots = [];
    const startOfDay = new Date(date);
    startOfDay.setHours(6, 0, 0, 0); // 6 AM

    const endOfDay = new Date(date);
    endOfDay.setHours(20, 0, 0, 0); // 8 PM
    
    let currentTime = startOfDay;
    while (currentTime.getTime() < endOfDay.getTime()) {
        slots.push(new Date(currentTime));
        currentTime.setMinutes(currentTime.getMinutes() + 30);
    }
    return slots;
}

export const getComputedDisplayName = (userData) => {
    const preferredDisplayName = userData.preferredDisplayName || '';
    const firstName = userData.firstName || '';
    const lastName = userData.lastName || '';
    const email = userData.email || '';
    
    if (preferredDisplayName) {
        return preferredDisplayName;
    }
    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    }
    if (email) {
        return email.split('@')[0];
    }
    return 'Guest';
};

export const getCalculatedAge = (dobString) => {
    if (!dobString) return 'N/A';
    try {
        const dob = new Date(dobString);
        if (isNaN(dob.getTime())) return 'N/A';

        const today = new Date();
        let ageYears = today.getFullYear() - dob.getFullYear();
        const monthDiff = today.getMonth() - dob.getMonth();
        
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
            ageYears--;
        }

        if (ageYears > 0) {
            return `${ageYears} ${ageYears === 1 ? 'year' : 'years'}`;
        } else {
            let ageMonths = (today.getFullYear() - dob.getFullYear()) * 12;
            ageMonths -= dob.getMonth();
            ageMonths += today.getMonth();
            
            if (today.getDate() < dob.getDate()) {
                ageMonths--;
            }
            
            if (ageMonths <= 0) {
                const diffTime = Math.abs(today.getTime() - dob.getTime());
                const ageDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                return `${ageDays} ${ageDays === 1 ? 'day' : 'days'}`;
            }
            
            return `${ageMonths} ${ageMonths === 1 ? 'month' : 'months'}`;
        }
    } catch (error) {
        console.error("Error calculating age:", error);
        return 'N/A';
    }
};
